import { Box, Container, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { motion } from "framer-motion";

function ProjectIntroSection() {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        overflow: "hidden",
        py: { xs: 6, md: 10 },
        background: `linear-gradient(135deg,
          ${theme.palette.primary.dark} 0%,
          ${theme.palette.primary.main} 45%,
          #000 140%)`,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: 420,
          height: 420,
          border: "3px solid rgba(255,255,255,0.12)",
          borderRadius: "50%",
          top: "-140px",
          left: "-140px",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 260,
          height: 260,
          border: "2px solid rgba(255,255,255,0.15)",
          borderRadius: "50%",
          bottom: "-80px",
          right: "-60px",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 600,
          height: 600,
          border: "2px dashed rgba(255,255,255,0.08)",
          borderRadius: "50%",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 20% 30%, rgba(255,255,255,0.08), transparent 40%), radial-gradient(circle at 80% 70%, rgba(255,255,255,0.06), transparent 45%)",
        }}
      />

      <Container maxWidth="md" sx={{ position: "relative", zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <Typography
            sx={{
              fontSize: { xs: "1.05rem", md: "1.2rem" },
              lineHeight: 1.8,
              textAlign: "center",
              color: "#fff",
            }}
          >
            At SAAC, we believe that{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              character and connection
            </Box>{" "}
            are best cultivated through{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              collaboration and competition
            </Box>
            . We view{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              interscholastic athletics, activities, and the arts
            </Box>{" "}
            as powerful tools for{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              personal growth
            </Box>
            , where students develop their abilities while also learning the
            values of{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              teamwork, resilience, and respect
            </Box>
            .
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
}

export default ProjectIntroSection;